import { render, staticRenderFns } from "./ProcedimentoCompartilhadoDataTable.vue?vue&type=template&id=fa5d682c"
import script from "./ProcedimentoCompartilhadoDataTable.vue?vue&type=script&lang=ts"
export * from "./ProcedimentoCompartilhadoDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports